<template>
  <div class="st-page">
    <Navigation />
    <div class="container" style="padding-top:20px;max-width:1300px;">
      <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
        <div class="d-flex align-items-center gap-3">
          <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="st-back"><i class="mdi mdi-arrow-left"></i></a>
          <h4 class="st-page-title"><i class="mdi mdi-hand-heart me-2"></i>Sponsored Students</h4>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <button class="btn btn-sm" :class="view === 'sponsors' ? 'st-btn-primary' : 'st-btn-outline'" @click="setView('sponsors')">🏢 Sponsors</button>
          <button class="btn btn-sm" :class="view === 'students' ? 'st-btn-primary' : 'st-btn-outline'" @click="setView('students')">👥 Students</button>
          <button class="btn st-btn-outline btn-sm" @click="loadAll" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>🔄
          </button>
          <button class="btn st-btn-outline btn-sm" @click="openReports()" title="Reports">📊 Reports</button>
          <button class="btn st-btn-outline btn-sm" @click="runBackfill" :disabled="backfillBusy" title="Apply the KSh 500 card fee to any sponsored students that were missed during conversion">
            <span v-if="backfillBusy" class="spinner-border spinner-border-sm me-1"></span>🛠 Backfill Card Fees
          </button>
          <button v-if="view === 'sponsors'" class="btn st-btn-primary btn-sm" @click="openSponsorForm()">+ New Sponsor</button>
          <button v-else class="btn st-btn-primary btn-sm" @click="showConvertForm = true">+ Add Sponsored Student</button>
        </div>
      </div>

      <!-- Headline KPIs -->
      <div class="pm-grid">
        <div class="pm-card" style="border-left-color:#4FC3F7;">
          <div class="pm-card-label">Active Sponsorships</div>
          <div class="pm-card-value" style="color:#4FC3F7;">{{ summary.active_count || 0 }}</div>
          <div class="pm-card-sub">students on credit</div>
        </div>
        <div class="pm-card" style="border-left-color:#EF4444;">
          <div class="pm-card-label">Outstanding Credit</div>
          <div class="pm-card-value" style="color:#EF4444;">KSh {{ fmt(summary.total_outstanding) }}</div>
          <div class="pm-card-sub">total negative balance</div>
        </div>
        <div class="pm-card" style="border-left-color:#10B981;">
          <div class="pm-card-label">Settled (All-time)</div>
          <div class="pm-card-value" style="color:#10B981;">KSh {{ fmt(summary.total_settled) }}</div>
          <div class="pm-card-sub">sponsor payments</div>
        </div>
      </div>

      <!-- SPONSORS VIEW -->
      <div v-if="view === 'sponsors'">
        <div class="st-section mb-3" style="padding:14px;">
          <div class="d-flex gap-2 flex-wrap align-items-end">
            <div>
              <label class="st-label" style="font-size:10px;">Status</label>
              <select class="st-input" v-model="sponsorFilters.status" @change="loadSponsors" style="padding:9px 10px;min-width:140px;">
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
                <option value="all">All</option>
              </select>
            </div>
            <div style="flex:1;min-width:200px;">
              <label class="st-label" style="font-size:10px;">Search</label>
              <input class="st-input" v-model="sponsorFilters.search" @keyup.enter="loadSponsors" placeholder="Sponsor / contact / phone / email…" />
            </div>
            <button class="btn st-btn-primary btn-sm" @click="loadSponsors" :disabled="loading">🔍</button>
          </div>
        </div>
        <div class="st-section" style="padding:14px;overflow-x:auto;">
          <div v-if="sponsors.length === 0 && !loading" class="text-center" style="padding:30px;color:#4A6A8A;font-size:13px;">
            No sponsors yet. Click "+ New Sponsor" to add one.
          </div>
          <table v-else class="pm-table">
            <thead><tr>
              <th>Sponsor</th><th>Contact</th><th>Type</th>
              <th class="text-end">Students</th><th class="text-end">Outstanding</th><th class="text-end">Settled</th>
              <th>Credit Cap</th><th>Status</th><th></th>
            </tr></thead>
            <tbody>
              <tr v-for="s in sponsors" :key="s.id">
                <td>
                  <div style="font-weight:600;color:#E8EDF4;">{{ s.name }}</div>
                  <div v-if="s.contact_person" style="font-size:11px;color:#8BA4C4;">{{ s.contact_person }}</div>
                </td>
                <td style="font-size:11px;color:#8BA4C4;">
                  <div v-if="s.phone">📞 {{ s.phone }}</div>
                  <div v-if="s.email">✉️ {{ s.email }}</div>
                </td>
                <td><span class="pm-badge" :class="s.type === 'ngo' ? 'pm-badge-info' : 'pm-badge-warn'">{{ s.type === 'ngo' ? 'NGO' : 'Individual' }}</span></td>
                <td class="text-end">{{ s.student_count }}</td>
                <td class="text-end" :style="{color: Number(s.total_outstanding) > 0 ? '#EF4444' : '#8BA4C4', fontWeight:600}">{{ fmt(s.total_outstanding) }}</td>
                <td class="text-end" style="color:#10B981;font-weight:600;">{{ fmt(s.total_settled) }}</td>
                <td style="min-width:160px;">
                  <div v-if="Number(s.credit_cap) > 0">
                    <div style="font-size:11px;color:#8BA4C4;">KSh {{ fmt(s.total_outstanding) }} / {{ fmt(s.credit_cap) }}</div>
                    <div style="height:6px;background:#1A3A6A;border-radius:3px;margin-top:3px;overflow:hidden;">
                      <div :style="{width: Math.min(100, Number(s.cap_used_pct||0)) + '%', height:'100%', background: capColor(s.cap_used_pct)}"></div>
                    </div>
                    <div style="font-size:10px;font-weight:600;margin-top:2px;" :style="{color: capColor(s.cap_used_pct)}">{{ s.cap_used_pct }}% used</div>
                  </div>
                  <div v-else style="font-size:10px;color:#4A6A8A;font-style:italic;">No cap</div>
                </td>
                <td><span class="pm-badge" :class="s.active == 1 ? 'pm-badge-ok' : 'pm-badge-reversed'">{{ s.active == 1 ? 'Active' : 'Inactive' }}</span></td>
                <td>
                  <div class="d-flex gap-1">
                    <button class="btn btn-sm" style="padding:2px 8px;font-size:11px;background:rgba(79,195,247,.12);color:#4FC3F7;border:1px solid rgba(79,195,247,.4);border-radius:6px;" @click="openSponsorDetail(s)" title="Open">📂</button>
                    <button class="btn btn-sm" style="padding:2px 8px;font-size:11px;background:rgba(168,85,247,.12);color:#A855F7;border:1px solid rgba(168,85,247,.4);border-radius:6px;" @click="openSponsorForm(s)" title="Edit">✎</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- STUDENTS VIEW -->
      <div v-if="view === 'students'">
      <!-- Filters -->
      <div class="st-section mb-3" style="padding:14px;">
        <div class="d-flex gap-2 flex-wrap align-items-end">
          <div>
            <label class="st-label" style="font-size:10px;">Status</label>
            <select class="st-input" v-model="filters.status" @change="loadList" style="padding:9px 10px;min-width:140px;">
              <option value="active">Active</option>
              <option value="ended">Ended</option>
              <option value="all">All</option>
            </select>
          </div>
          <div style="flex:1;min-width:200px;">
            <label class="st-label" style="font-size:10px;">Search</label>
            <input class="st-input" v-model="filters.search" @keyup.enter="loadList" placeholder="Sponsor name, student name, or admission no…" />
          </div>
          <button class="btn st-btn-primary btn-sm" @click="loadList" :disabled="loading">🔍</button>
        </div>
      </div>

      <!-- List -->
      <div class="st-section" style="padding:14px;overflow-x:auto;">
        <div v-if="sponsorships.length === 0 && !loading" class="text-center" style="padding:30px;color:#4A6A8A;font-size:13px;">
          No sponsorships yet. Click "+ Add Sponsored Student" to start.
        </div>
        <table v-else class="pm-table">
          <thead><tr>
            <th>Student</th><th>Sponsor</th><th>Type</th>
            <th class="text-end">Outstanding</th><th class="text-end">Today Used</th>
            <th class="text-end">Limits (Daily / Credit)</th>
            <th class="text-end">Settled</th><th>Status</th><th></th>
          </tr></thead>
          <tbody>
            <tr v-for="s in sponsorships" :key="s.id">
              <td>
                <div style="font-weight:600;color:#E8EDF4;">{{ s.student_name }}</div>
                <div style="font-size:11px;color:#8BA4C4;">{{ s.admission_no }}</div>
              </td>
              <td>
                <div style="font-weight:600;color:#E8EDF4;">{{ s.sponsor_name }}</div>
                <div style="font-size:11px;color:#8BA4C4;">{{ s.sponsor_phone || s.sponsor_email || '' }}</div>
              </td>
              <td>
                <span class="pm-badge" :class="s.sponsor_type === 'ngo' ? 'pm-badge-info' : 'pm-badge-warn'">{{ s.sponsor_type === 'ngo' ? 'NGO' : 'Individual' }}</span>
              </td>
              <td class="text-end" :style="{color: Number(s.outstanding) > 0 ? '#EF4444' : '#8BA4C4', fontWeight:600}">
                {{ fmt(s.outstanding) }}
              </td>
              <td class="text-end">
                <span :style="{color: Number(s.today_spent) > 0 ? '#F59E0B' : '#8BA4C4'}">{{ fmt(s.today_spent) }}</span>
                <span style="color:#4A6A8A;font-size:10px;"> / {{ fmt(s.spend_limit_daily, 0) }}</span>
              </td>
              <td class="text-end" style="font-size:11px;color:#8BA4C4;">{{ fmt(s.spend_limit_daily, 0) }} / {{ fmt(s.credit_limit, 0) }}</td>
              <td class="text-end" style="color:#10B981;font-weight:600;">{{ fmt(s.settled_total) }}</td>
              <td>
                <span v-if="s.active == 1" class="pm-badge pm-badge-ok">Active</span>
                <span v-else class="pm-badge pm-badge-reversed">Ended</span>
              </td>
              <td>
                <div class="d-flex gap-1">
                  <button v-if="s.active == 1" class="btn btn-sm" style="padding:2px 8px;font-size:11px;background:rgba(16,185,129,.12);color:#10B981;border:1px solid rgba(16,185,129,.4);border-radius:6px;"
                          @click="openSettle(s)" title="Record sponsor payment">💵</button>
                  <button class="btn btn-sm" style="padding:2px 8px;font-size:11px;background:rgba(79,195,247,.12);color:#4FC3F7;border:1px solid rgba(79,195,247,.4);border-radius:6px;"
                          @click="openDetail(s)" title="Statement">📜</button>
                  <button v-if="s.active == 1" class="btn btn-sm" style="padding:2px 8px;font-size:11px;background:rgba(239,68,68,.12);color:#EF4444;border:1px solid rgba(239,68,68,.4);border-radius:6px;"
                          @click="endIt(s)" title="End sponsorship">✕</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </div><!-- /STUDENTS VIEW -->

      <!-- Reports modal -->
      <div v-if="reportsOpen" class="pm-overlay" @click.self="reportsOpen = false">
        <div class="pm-modal" style="max-width:960px;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 style="color:#E8EDF4;margin:0;"><i class="mdi mdi-chart-box me-1"></i>Sponsorship Reports</h5>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="reportsOpen=false">✕</button>
          </div>

          <div class="d-flex gap-2 flex-wrap mb-3">
            <button class="btn btn-sm" :class="reportTab === 'csv' ? 'st-btn-primary' : 'st-btn-outline'" @click="setReportTab('csv')">📥 Roll-up CSV</button>
            <button class="btn btn-sm" :class="reportTab === 'cap' ? 'st-btn-primary' : 'st-btn-outline'" @click="setReportTab('cap')">⏱ Daily Cap</button>
            <button class="btn btn-sm" :class="reportTab === 'trend' ? 'st-btn-primary' : 'st-btn-outline'" @click="setReportTab('trend')">📈 Monthly Trend</button>
            <button class="btn btn-sm" :class="reportTab === 'lapsed' ? 'st-btn-primary' : 'st-btn-outline'" @click="setReportTab('lapsed')">🔚 Lapsed</button>
          </div>

          <!-- ROLL-UP CSV -->
          <div v-if="reportTab === 'csv'">
            <div style="font-size:13px;color:#8BA4C4;margin-bottom:10px;">
              Download a single CSV covering every sponsor (or every sponsored student) in one go.
            </div>
            <div class="row g-2">
              <div class="col-12 col-md-6">
                <div class="st-info-box" style="padding:14px;">
                  <h6 style="color:#E8EDF4;margin-bottom:6px;">Summary (one row per sponsor)</h6>
                  <div style="font-size:11px;color:#8BA4C4;margin-bottom:10px;">Sponsor · Type · Contact · Active Students · Outstanding · Settled · Monthly Budget</div>
                  <button class="btn st-btn-primary btn-sm" @click="downloadCsv('summary')" :disabled="csvBusy">
                    <span v-if="csvBusy" class="spinner-border spinner-border-sm me-1"></span>Download Summary CSV
                  </button>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="st-info-box" style="padding:14px;">
                  <h6 style="color:#E8EDF4;margin-bottom:6px;">Detail (one row per student)</h6>
                  <div style="font-size:11px;color:#8BA4C4;margin-bottom:10px;">Sponsor · Student · Admission · Wallet · Outstanding · Daily/Credit Limits · Today Spent · Settled</div>
                  <button class="btn st-btn-primary btn-sm" @click="downloadCsv('detail')" :disabled="csvBusy">
                    <span v-if="csvBusy" class="spinner-border spinner-border-sm me-1"></span>Download Detail CSV
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- DAILY CAP -->
          <div v-if="reportTab === 'cap'">
            <div v-if="dailyCap" class="pm-grid" style="margin-bottom:12px;">
              <div class="pm-card" style="border-left-color:#EF4444;padding:10px;">
                <div class="pm-card-label">Capped Today</div>
                <div class="pm-card-value" style="color:#EF4444;font-size:18px;">{{ dailyCap.buckets.capped }}</div>
              </div>
              <div class="pm-card" style="border-left-color:#F59E0B;padding:10px;">
                <div class="pm-card-label">90–100% Used</div>
                <div class="pm-card-value" style="color:#F59E0B;font-size:18px;">{{ dailyCap.buckets['90_100'] }}</div>
              </div>
              <div class="pm-card" style="border-left-color:#4FC3F7;padding:10px;">
                <div class="pm-card-label">50–90% Used</div>
                <div class="pm-card-value" style="color:#4FC3F7;font-size:18px;">{{ dailyCap.buckets['50_90'] }}</div>
              </div>
              <div class="pm-card" style="border-left-color:#10B981;padding:10px;">
                <div class="pm-card-label">Below 50%</div>
                <div class="pm-card-value" style="color:#10B981;font-size:18px;">{{ dailyCap.buckets.under_50 }}</div>
              </div>
            </div>
            <div v-if="dailyCap" style="overflow-x:auto;max-height:420px;">
              <table class="pm-table">
                <thead><tr>
                  <th>Student</th><th>Sponsor</th>
                  <th class="text-end">Today / Limit</th><th class="text-end">% Used</th>
                  <th>Usage Bar</th>
                  <th class="text-end">7d Avg</th><th class="text-end">Days ≥90% (7d)</th>
                </tr></thead>
                <tbody>
                  <tr v-for="r in dailyCap.rows" :key="r.sponsorship_id">
                    <td><div style="color:#E8EDF4;">{{ r.student_name }}</div><div style="font-size:11px;color:#8BA4C4;">{{ r.admission_no }}</div></td>
                    <td>{{ r.sponsor_name }}</td>
                    <td class="text-end"><span :style="{color: r.pct_used >= 90 ? '#EF4444' : (r.pct_used >= 50 ? '#F59E0B' : '#10B981')}">{{ fmt(r.today_spent) }}</span> / {{ fmt(r.daily_limit, 0) }}</td>
                    <td class="text-end" style="font-weight:700;" :style="{color: capColor(r.bucket)}">{{ r.pct_used }}%</td>
                    <td style="min-width:120px;">
                      <div class="prog-track"><div class="prog-fill" :style="{width: Math.min(100, r.pct_used) + '%', background: capColor(r.bucket)}"></div></div>
                    </td>
                    <td class="text-end">{{ fmt(r.avg_7d) }}</td>
                    <td class="text-end" :style="{color: r.days_hit_cap_7d > 0 ? '#F59E0B' : '#8BA4C4'}">{{ r.days_hit_cap_7d }}/7</td>
                  </tr>
                  <tr v-if="!dailyCap.rows.length"><td colspan="7" style="text-align:center;color:#4A6A8A;padding:18px;">No sponsored students with a daily cap configured.</td></tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="reportBusy" class="text-center" style="padding:30px;"><div class="spinner-border"></div></div>
          </div>

          <!-- MONTHLY TREND -->
          <div v-if="reportTab === 'trend'">
            <div class="d-flex gap-2 align-items-end mb-3 flex-wrap">
              <div>
                <label class="st-label" style="font-size:10px;">Window</label>
                <select class="st-input" v-model.number="trendMonths" @change="loadTrend" style="padding:9px 10px;min-width:120px;">
                  <option :value="3">Last 3 months</option>
                  <option :value="6">Last 6 months</option>
                  <option :value="12">Last 12 months</option>
                </select>
              </div>
            </div>
            <div v-if="trend" style="overflow-x:auto;max-height:500px;">
              <table class="pm-table">
                <thead><tr>
                  <th style="position:sticky;left:0;background:#0A1628;z-index:1;">Sponsor</th>
                  <th v-for="m in trend.months" :key="m" class="text-end" style="font-size:10px;">{{ formatMonth(m) }}</th>
                  <th class="text-end" style="color:#10B981;">Total Settled</th>
                  <th class="text-end" style="color:#F59E0B;">Total Spent</th>
                </tr></thead>
                <tbody>
                  <tr v-for="s in trend.series" :key="s.sponsor_id">
                    <td style="position:sticky;left:0;background:#0F2347;color:#E8EDF4;font-weight:600;">{{ s.sponsor_name }}</td>
                    <td v-for="m in s.monthly" :key="m.month" class="text-end">
                      <div style="color:#10B981;font-size:11px;">+{{ fmt(m.settled, 0) }}</div>
                      <div style="color:#F59E0B;font-size:11px;">−{{ fmt(m.spent, 0) }}</div>
                    </td>
                    <td class="text-end" style="color:#10B981;font-weight:700;">{{ fmt(s.total_settled) }}</td>
                    <td class="text-end" style="color:#F59E0B;font-weight:700;">{{ fmt(s.total_spent) }}</td>
                  </tr>
                  <tr v-if="!trend.series.length"><td :colspan="trend.months.length + 3" style="text-align:center;color:#4A6A8A;padding:18px;">No activity in this window.</td></tr>
                  <tr v-else style="background:#0A1628;border-top:2px solid #1A3A6A;">
                    <td style="position:sticky;left:0;background:#0A1628;color:#4FC3F7;font-weight:700;">ALL SPONSORS</td>
                    <td v-for="(t, i) in trend.totals_by_month" :key="'tot-' + i" class="text-end">
                      <div style="color:#10B981;font-size:11px;">+{{ fmt(t.settled, 0) }}</div>
                      <div style="color:#F59E0B;font-size:11px;">−{{ fmt(t.spent, 0) }}</div>
                    </td>
                    <td class="text-end" style="color:#10B981;font-weight:700;">{{ fmt(trendTotals.settled) }}</td>
                    <td class="text-end" style="color:#F59E0B;font-weight:700;">{{ fmt(trendTotals.spent) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="reportBusy" class="text-center" style="padding:30px;"><div class="spinner-border"></div></div>
          </div>

          <!-- LAPSED -->
          <div v-if="reportTab === 'lapsed'">
            <div class="d-flex gap-2 align-items-end mb-3 flex-wrap">
              <div>
                <label class="st-label" style="font-size:10px;">Window</label>
                <select class="st-input" v-model.number="lapsedDays" @change="loadLapsed" style="padding:9px 10px;min-width:120px;">
                  <option :value="7">Last 7 days</option>
                  <option :value="30">Last 30 days</option>
                  <option :value="90">Last 90 days</option>
                  <option :value="365">Last 12 months</option>
                </select>
              </div>
              <div v-if="lapsed" class="ms-auto" style="font-size:13px;color:#8BA4C4;align-self:center;">
                <strong style="color:#EF4444;">{{ lapsed.count }}</strong> lapsed · Outstanding total: <strong style="color:#EF4444;">KSh {{ fmt(lapsed.total_outstanding) }}</strong>
              </div>
            </div>
            <div v-if="lapsed" style="overflow-x:auto;max-height:450px;">
              <table class="pm-table">
                <thead><tr><th>Student</th><th>Sponsor</th><th>Start</th><th>Ended</th><th class="text-end">Outstanding</th><th>Wallet Mode</th></tr></thead>
                <tbody>
                  <tr v-for="r in lapsed.rows" :key="r.sponsorship_id">
                    <td><div style="color:#E8EDF4;">{{ r.student_name }}</div><div style="font-size:11px;color:#8BA4C4;">{{ r.admission_no }}</div></td>
                    <td>{{ r.sponsor_name }}</td>
                    <td style="font-size:11px;">{{ r.start_date }}</td>
                    <td style="font-size:11px;color:#EF4444;">{{ r.end_date }}</td>
                    <td class="text-end" :style="{color: Number(r.outstanding) > 0 ? '#EF4444' : '#8BA4C4', fontWeight:600}">{{ fmt(r.outstanding) }}</td>
                    <td>
                      <span v-if="r.still_credit == 1" class="pm-badge pm-badge-warn">Credit (unreverted)</span>
                      <span v-else class="pm-badge pm-badge-ok">Prepaid</span>
                    </td>
                  </tr>
                  <tr v-if="!lapsed.rows.length"><td colspan="6" style="text-align:center;color:#4A6A8A;padding:18px;">No sponsorships lapsed in this window.</td></tr>
                </tbody>
              </table>
            </div>
            <div v-else-if="reportBusy" class="text-center" style="padding:30px;"><div class="spinner-border"></div></div>
          </div>
        </div>
      </div>

      <!-- Sponsor create/edit modal -->
      <div v-if="sponsorFormOpen" class="pm-overlay" @click.self="sponsorFormOpen = false">
        <div class="pm-modal">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 style="color:#E8EDF4;margin:0;">{{ sponsorForm.id ? 'Edit Sponsor' : 'New Sponsor' }}</h5>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="sponsorFormOpen=false">✕</button>
          </div>
          <div class="row g-2">
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Sponsor Type</label>
              <select class="st-input" v-model="sponsorForm.type" style="padding:9px 10px;">
                <option value="ngo">NGO (e.g. UNICEF)</option>
                <option value="individual">Individual</option>
              </select>
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Sponsor Name</label>
              <input class="st-input" v-model="sponsorForm.name" placeholder="UNICEF Kenya / John Doe" />
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Contact Person</label>
              <input class="st-input" v-model="sponsorForm.contact_person" placeholder="e.g. Ms. Achieng" />
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Phone</label>
              <input class="st-input" v-model="sponsorForm.phone" placeholder="07…" />
            </div>
            <div class="col-12">
              <label class="st-label" style="font-size:10px;">Email</label>
              <input class="st-input" v-model="sponsorForm.email" placeholder="" />
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Monthly Budget (opt)</label>
              <input type="number" class="st-input" v-model="sponsorForm.monthly_budget" placeholder="Planning figure only" />
              <small style="font-size:10px;color:#8BA4C4;">Reference / planning only — not enforced.</small>
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Status</label>
              <select class="st-input" v-model="sponsorForm.active" style="padding:9px 10px;">
                <option :value="1">Active</option>
                <option :value="0">Inactive</option>
              </select>
            </div>
            <div class="col-12">
              <label class="st-label" style="font-size:10px;color:#F59E0B;">🛡 Credit Cap (hard limit, opt)</label>
              <input type="number" class="st-input" v-model="sponsorForm.credit_cap" placeholder="e.g. 400000" />
              <small style="font-size:10px;color:#F59E0B;">When the sponsor's total outstanding hits this, POS sales for ALL their students are blocked until they settle. Leave blank for no hard cap.</small>
            </div>
            <div class="col-12">
              <label class="st-label" style="font-size:10px;">Notes</label>
              <input class="st-input" v-model="sponsorForm.notes" />
            </div>
          </div>
          <div class="d-flex gap-2 mt-3">
            <button class="btn st-btn-primary btn-sm" @click="submitSponsor" :disabled="!sponsorForm.name || savingSponsor">
              <span v-if="savingSponsor" class="spinner-border spinner-border-sm me-1"></span>{{ sponsorForm.id ? 'Update' : 'Create' }}
            </button>
            <button class="btn st-btn-outline btn-sm" @click="sponsorFormOpen=false">Cancel</button>
          </div>
        </div>
      </div>

      <!-- Sponsor detail drawer -->
      <div v-if="sponsorDetail" class="pm-overlay" @click.self="sponsorDetail = null">
        <div class="pm-modal" style="max-width:920px;">
          <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <div>
              <h5 style="color:#E8EDF4;margin:0;">{{ sponsorDetail.sponsor.name }}
                <span class="pm-badge" :class="sponsorDetail.sponsor.type === 'ngo' ? 'pm-badge-info' : 'pm-badge-warn'" style="margin-left:8px;font-size:10px;">{{ sponsorDetail.sponsor.type === 'ngo' ? 'NGO' : 'Individual' }}</span>
              </h5>
              <div style="font-size:11px;color:#8BA4C4;margin-top:2px;">
                {{ sponsorDetail.sponsor.contact_person || '—' }} · {{ sponsorDetail.sponsor.phone || '—' }} · {{ sponsorDetail.sponsor.email || '—' }}
              </div>
            </div>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="sponsorDetail=null">✕</button>
          </div>

          <div class="pm-grid" style="margin-bottom:14px;">
            <div class="pm-card" style="border-left-color:#4FC3F7;padding:10px;">
              <div class="pm-card-label">Active Students</div>
              <div class="pm-card-value" style="color:#4FC3F7;font-size:18px;">{{ sponsorDetail.active_students }}</div>
            </div>
            <div class="pm-card" style="border-left-color:#EF4444;padding:10px;">
              <div class="pm-card-label">Outstanding</div>
              <div class="pm-card-value" style="color:#EF4444;font-size:18px;">KSh {{ fmt(sponsorDetail.total_outstanding) }}</div>
            </div>
            <div class="pm-card" style="border-left-color:#10B981;padding:10px;">
              <div class="pm-card-label">Total Settled</div>
              <div class="pm-card-value" style="color:#10B981;font-size:18px;">KSh {{ fmt(sponsorDetail.total_settled) }}</div>
            </div>
          </div>

          <!-- Credit Cap progress -->
          <div v-if="Number(sponsorDetail.sponsor.credit_cap) > 0" class="st-section mb-3" style="padding:12px;">
            <div class="d-flex justify-content-between align-items-center" style="font-size:12px;color:#8BA4C4;">
              <div><span style="color:#F59E0B;font-weight:600;">🛡 Credit Cap</span> &middot; KSh {{ fmt(sponsorDetail.total_outstanding) }} of KSh {{ fmt(sponsorDetail.sponsor.credit_cap) }}</div>
              <div :style="{color: capColor(detailCapPct), fontWeight:700}">{{ detailCapPct }}% used</div>
            </div>
            <div style="height:10px;background:#1A3A6A;border-radius:5px;margin-top:6px;overflow:hidden;">
              <div :style="{width: Math.min(100, detailCapPct) + '%', height:'100%', background: capColor(detailCapPct), transition:'width .3s'}"></div>
            </div>
            <div v-if="detailCapPct >= 95" style="font-size:11px;color:#EF4444;margin-top:6px;">⚠ Cap reached — POS sales for ALL students under this sponsor are blocked until settled.</div>
            <div v-else-if="detailCapPct >= 80" style="font-size:11px;color:#F59E0B;margin-top:6px;">⚠ Approaching cap — only KSh {{ fmt(Number(sponsorDetail.sponsor.credit_cap) - Number(sponsorDetail.total_outstanding)) }} of credit remaining.</div>
          </div>

          <div class="d-flex gap-2 flex-wrap mb-3">
            <button class="btn st-btn-primary btn-sm" @click="openBulkConvert(sponsorDetail.sponsor)">➕ Add Students</button>
            <button class="btn btn-sm" style="background:rgba(16,185,129,.15);color:#10B981;border:1px solid rgba(16,185,129,.4);border-radius:8px;padding:6px 12px;font-size:12px;font-weight:600;" @click="openBulkSettle(sponsorDetail.sponsor)">💵 Record Payment</button>
            <button class="btn st-btn-outline btn-sm" @click="downloadStatementPdf(sponsorDetail.sponsor)" :disabled="statementBusy">
              <span v-if="statementBusy" class="spinner-border spinner-border-sm me-1"></span>📄 Statement PDF
            </button>
            <button class="btn st-btn-outline btn-sm" @click="emailStatement(sponsorDetail.sponsor)" :disabled="statementBusy || !sponsorDetail.sponsor.email">✉️ Email Statement</button>
            <button class="btn st-btn-outline btn-sm" @click="getPortalLink(sponsorDetail.sponsor)" :disabled="portalBusy">🔗 Portal Link</button>
            <button class="btn st-btn-outline btn-sm" @click="sendPortalLink(sponsorDetail.sponsor, 'sms')" :disabled="portalBusy || !sponsorDetail.sponsor.phone">📱 SMS Link</button>
            <button class="btn st-btn-outline btn-sm" @click="sendPortalLink(sponsorDetail.sponsor, 'email')" :disabled="portalBusy || !sponsorDetail.sponsor.email">✉️ Email Link</button>
          </div>

          <div v-if="portalLink" class="st-info-box mb-3" style="padding:10px;font-size:12px;">
            <div style="color:#8BA4C4;font-size:10px;text-transform:uppercase;font-weight:600;">Portal Link (read-only, share with sponsor):</div>
            <a :href="portalLink" target="_blank" style="color:#4FC3F7;word-break:break-all;">{{ portalLink }}</a>
          </div>

          <div style="font-size:11px;color:#4A6A8A;text-transform:uppercase;font-weight:600;margin:8px 0 4px;">Sponsored Students ({{ sponsorDetail.sponsorships.length }})</div>
          <div style="overflow-x:auto;max-height:260px;">
            <table class="pm-table">
              <thead><tr><th>Student</th><th>Admission</th><th class="text-end">Outstanding</th><th class="text-end">Today</th><th>Status</th></tr></thead>
              <tbody>
                <tr v-for="r in sponsorDetail.sponsorships" :key="r.id">
                  <td style="color:#E8EDF4;">{{ r.student_name }}</td>
                  <td style="font-size:11px;color:#8BA4C4;">{{ r.admission_no }}</td>
                  <td class="text-end" :style="{color: Number(r.outstanding) > 0 ? '#EF4444' : '#8BA4C4', fontWeight:600}">{{ fmt(r.outstanding) }}</td>
                  <td class="text-end">{{ fmt(r.today_spent) }} / {{ fmt(r.spend_limit_daily, 0) }}</td>
                  <td><span class="pm-badge" :class="r.active == 1 ? 'pm-badge-ok' : 'pm-badge-reversed'">{{ r.active == 1 ? 'Active' : 'Ended' }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style="font-size:11px;color:#4A6A8A;text-transform:uppercase;font-weight:600;margin:14px 0 4px;">Recent Settlements ({{ sponsorDetail.settlements.length }})</div>
          <div style="overflow-x:auto;max-height:220px;">
            <table class="pm-table">
              <thead><tr><th>Date</th><th>Method</th><th>M-Pesa</th><th>Batch</th><th class="text-end">Amount</th><th></th></tr></thead>
              <tbody>
                <tr v-for="t in sponsorDetail.settlements" :key="t.id">
                  <td>{{ t.paid_on }}</td>
                  <td>{{ t.payment_method }}</td>
                  <td style="font-family:monospace;font-size:11px;color:#8BA4C4;">{{ t.mpesa_code || '—' }}</td>
                  <td style="font-family:monospace;font-size:10px;color:#8BA4C4;">{{ t.batch_ref || '—' }}</td>
                  <td class="text-end" style="color:#10B981;font-weight:600;">{{ fmt(t.amount) }}</td>
                  <td>
                    <button class="btn btn-sm" style="padding:2px 8px;font-size:11px;background:rgba(239,68,68,.12);color:#EF4444;border:1px solid rgba(239,68,68,.4);border-radius:6px;"
                            @click="reverseSettlement(t)" :disabled="reversingId === t.id" title="Reverse">
                      <span v-if="reversingId === t.id" class="spinner-border spinner-border-sm me-1"></span>↩
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Bulk-convert modal -->
      <div v-if="bulkConvertOpen" class="pm-overlay" @click.self="bulkConvertOpen = false">
        <div class="pm-modal" style="max-width:640px;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 style="color:#E8EDF4;margin:0;">Add Students to {{ bulkConvertSponsor.name }}</h5>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="bulkConvertOpen=false">✕</button>
          </div>

          <label class="st-label" style="font-size:10px;">Search students</label>
          <input class="st-input" v-model="bulkSearch" @input="searchBulkStudents" placeholder="Name or admission no…" />
          <div v-if="bulkStudentResults.length" class="mt-2" style="max-height:200px;overflow-y:auto;">
            <div v-for="s in bulkStudentResults" :key="s.id" class="pm-student" :class="bulkSelectedIds.includes(s.id) ? 'selected' : ''" @click="toggleBulkSelect(s)">
              <div style="display:flex;justify-content:space-between;align-items:center;">
                <div>
                  <strong>{{ s.name }}</strong> <span style="color:#8BA4C4;font-size:11px;">· {{ s.admission_no }}</span>
                </div>
                <div style="font-size:11px;">
                  <span v-if="s.is_sponsored == 1" class="pm-badge pm-badge-info" style="margin-right:6px;">Already sponsored</span>
                  <span v-if="bulkSelectedIds.includes(s.id)" style="color:#10B981;">✓ Selected</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="bulkSelectedIds.length" class="mt-3" style="font-size:12px;color:#8BA4C4;">
            <strong style="color:#E8EDF4;">{{ bulkSelectedIds.length }} student(s) selected.</strong> They will be flipped to credit wallets and charged the KES 500 card fee if unpaid.
          </div>

          <div class="row g-2 mt-2">
            <div class="col-4">
              <label class="st-label" style="font-size:10px;">Daily Limit</label>
              <input type="number" class="st-input" v-model="bulkConvertForm.daily_limit" />
            </div>
            <div class="col-4">
              <label class="st-label" style="font-size:10px;">Credit Limit</label>
              <input type="number" class="st-input" v-model="bulkConvertForm.credit_limit" />
            </div>
            <div class="col-4">
              <label class="st-label" style="font-size:10px;">Start Date</label>
              <input type="date" class="st-input" v-model="bulkConvertForm.start_date" />
            </div>
          </div>
          <div class="d-flex gap-2 mt-3">
            <button class="btn st-btn-primary btn-sm" @click="submitBulkConvert" :disabled="!bulkSelectedIds.length || bulkConverting">
              <span v-if="bulkConverting" class="spinner-border spinner-border-sm me-1"></span>Convert {{ bulkSelectedIds.length || '' }} students
            </button>
            <button class="btn st-btn-outline btn-sm" @click="bulkConvertOpen=false">Cancel</button>
          </div>
        </div>
      </div>

      <!-- Bulk-settle modal -->
      <div v-if="bulkSettleOpen" class="pm-overlay" @click.self="bulkSettleOpen = false">
        <div class="pm-modal" style="max-width:720px;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 style="color:#E8EDF4;margin:0;">Record Payment from {{ bulkSettleSponsor.name }}</h5>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="bulkSettleOpen=false">✕</button>
          </div>

          <div class="row g-2">
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Paid On</label>
              <input type="date" class="st-input" v-model="bulkSettleForm.paid_on" />
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Amount (KES)</label>
              <input type="number" class="st-input" v-model.number="bulkSettleForm.amount" @input="refreshBulkPreview" />
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Method</label>
              <select class="st-input" v-model="bulkSettleForm.payment_method" style="padding:9px 10px;">
                <option value="mpesa">M-Pesa</option><option value="bank">Bank</option>
                <option value="cash">Cash</option><option value="cheque">Cheque</option><option value="other">Other</option>
              </select>
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">M-Pesa Code (if any)</label>
              <input class="st-input" v-model="bulkSettleForm.mpesa_code" style="text-transform:uppercase;" />
            </div>
            <div class="col-12">
              <label class="st-label" style="font-size:10px;">Allocation Method</label>
              <div class="d-flex gap-2 flex-wrap">
                <button class="btn btn-sm" :class="bulkSettleForm.allocation === 'proportional' ? 'st-btn-primary' : 'st-btn-outline'" @click="setAllocation('proportional')">Proportional to Outstanding</button>
                <button class="btn btn-sm" :class="bulkSettleForm.allocation === 'equal' ? 'st-btn-primary' : 'st-btn-outline'" @click="setAllocation('equal')">Equal Split</button>
                <button class="btn btn-sm" :class="bulkSettleForm.allocation === 'manual' ? 'st-btn-primary' : 'st-btn-outline'" @click="setAllocation('manual')">Manual</button>
              </div>
            </div>
            <div class="col-12">
              <label class="st-label" style="font-size:10px;">Notes</label>
              <input class="st-input" v-model="bulkSettleForm.notes" />
            </div>
          </div>

          <div v-if="bulkSettlePreview.length" class="mt-3">
            <div style="font-size:11px;color:#4A6A8A;text-transform:uppercase;font-weight:600;margin-bottom:6px;">Allocation Preview ({{ bulkSettlePreview.length }} students)</div>
            <div style="overflow-x:auto;max-height:280px;">
              <table class="pm-table">
                <thead><tr><th>Student</th><th class="text-end">Outstanding</th><th class="text-end">Allocated</th></tr></thead>
                <tbody>
                  <tr v-for="p in bulkSettlePreview" :key="p.sponsorship_id">
                    <td>{{ p.student_name }} <span style="color:#8BA4C4;font-size:11px;">· {{ p.admission_no }}</span></td>
                    <td class="text-end" :style="{color: Number(p.outstanding) > 0 ? '#EF4444' : '#8BA4C4'}">{{ fmt(p.outstanding) }}</td>
                    <td class="text-end" style="font-weight:600;color:#10B981;">
                      <input v-if="bulkSettleForm.allocation === 'manual'" type="number" step="0.01" class="st-input" style="text-align:right;max-width:120px;display:inline-block;" v-model.number="manualSplit[p.sponsorship_id]" />
                      <span v-else>{{ fmt(p.allocated) }}</span>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="background:#0A1628;">
                    <td><strong>Total</strong></td>
                    <td></td>
                    <td class="text-end" :style="{color: previewTotalMatches ? '#10B981' : '#EF4444', fontWeight:700}">
                      {{ fmt(previewSum) }}
                      <span v-if="!previewTotalMatches" style="font-size:11px;color:#EF4444;"> ≠ {{ fmt(bulkSettleForm.amount) }}</span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="d-flex gap-2 mt-3">
            <button class="btn st-btn-primary btn-sm" @click="submitBulkSettle" :disabled="!canSubmitBulkSettle || bulkSettling">
              <span v-if="bulkSettling" class="spinner-border spinner-border-sm me-1"></span>Record & Credit Wallets
            </button>
            <button class="btn st-btn-outline btn-sm" @click="bulkSettleOpen=false">Cancel</button>
          </div>
        </div>
      </div>

      <!-- Convert / Add modal -->
      <div v-if="showConvertForm" class="pm-overlay" @click.self="showConvertForm = false">
        <div class="pm-modal">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 style="color:#E8EDF4;margin:0;">Add Sponsored Student</h5>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="showConvertForm=false">✕</button>
          </div>

          <label class="st-label" style="font-size:10px;">Student</label>
          <input class="st-input" v-model="studentSearch" @input="searchStudents" placeholder="Search by name or admission no…" />
          <div v-if="studentResults.length" class="mt-2" style="max-height:160px;overflow-y:auto;">
            <div v-for="s in studentResults" :key="s.id"
                 class="pm-student" :class="selectedStudent && selectedStudent.id === s.id ? 'selected' : ''"
                 @click="selectStudent(s)">
              <div style="display:flex;justify-content:space-between;">
                <strong>{{ s.name }}</strong>
                <span v-if="s.is_sponsored == 1" class="pm-badge pm-badge-info" style="font-size:9px;">Already sponsored</span>
              </div>
              <div style="font-size:11px;color:#8BA4C4;">{{ s.admission_no }} · {{ s.class_name || 'No class' }} · Bal: KSh {{ fmt(s.balance) }}</div>
            </div>
          </div>

          <div v-if="selectedStudent" class="mt-3">
            <div class="row g-2">
              <div class="col-6">
                <label class="st-label" style="font-size:10px;">Sponsor Type</label>
                <select class="st-input" v-model="convertForm.sponsor_type" style="padding:9px 10px;">
                  <option value="ngo">NGO (e.g. UNICEF)</option>
                  <option value="individual">Individual</option>
                </select>
              </div>
              <div class="col-6">
                <label class="st-label" style="font-size:10px;">Sponsor Name</label>
                <input class="st-input" v-model="convertForm.sponsor_name" placeholder="UNICEF / John Doe" />
              </div>
              <div class="col-6">
                <label class="st-label" style="font-size:10px;">Phone</label>
                <input class="st-input" v-model="convertForm.sponsor_phone" placeholder="07…" />
              </div>
              <div class="col-6">
                <label class="st-label" style="font-size:10px;">Email</label>
                <input class="st-input" v-model="convertForm.sponsor_email" placeholder="" />
              </div>
              <div class="col-4">
                <label class="st-label" style="font-size:10px;">Daily Limit (KES)</label>
                <input type="number" class="st-input" v-model="convertForm.daily_limit" />
              </div>
              <div class="col-4">
                <label class="st-label" style="font-size:10px;">Credit Limit (KES)</label>
                <input type="number" class="st-input" v-model="convertForm.credit_limit" />
              </div>
              <div class="col-4">
                <label class="st-label" style="font-size:10px;">Monthly Budget (opt)</label>
                <input type="number" class="st-input" v-model="convertForm.monthly_budget" />
              </div>
              <div class="col-6">
                <label class="st-label" style="font-size:10px;">Start Date</label>
                <input type="date" class="st-input" v-model="convertForm.start_date" />
              </div>
              <div class="col-6">
                <label class="st-label" style="font-size:10px;">End Date (opt)</label>
                <input type="date" class="st-input" v-model="convertForm.end_date" />
              </div>
              <div class="col-12">
                <label class="st-label" style="font-size:10px;">Notes</label>
                <input class="st-input" v-model="convertForm.notes" placeholder="" />
              </div>
            </div>
            <div class="mt-3" style="font-size:11px;color:#F59E0B;background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.3);border-radius:8px;padding:8px 12px;">
              ⚠ On save: wallet is converted to <strong>credit mode</strong> and the <strong>KSh 500 card fee</strong> will be auto-charged (pushing balance to −500 if unpaid).
            </div>
            <div class="d-flex gap-2 mt-3">
              <button class="btn st-btn-primary btn-sm" @click="submitConvert" :disabled="!canConvert || converting">
                <span v-if="converting" class="spinner-border spinner-border-sm me-1"></span>Save
              </button>
              <button class="btn st-btn-outline btn-sm" @click="showConvertForm=false">Cancel</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Settlement modal -->
      <div v-if="settleSponsorship" class="pm-overlay" @click.self="settleSponsorship = null">
        <div class="pm-modal">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 style="color:#E8EDF4;margin:0;">Record Sponsor Payment</h5>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="settleSponsorship=null">✕</button>
          </div>
          <div style="font-size:13px;color:#8BA4C4;margin-bottom:12px;">
            For <strong style="color:#E8EDF4;">{{ settleSponsorship.student_name }}</strong> ({{ settleSponsorship.admission_no }})
            sponsored by <strong style="color:#E8EDF4;">{{ settleSponsorship.sponsor_name }}</strong>.
            Outstanding: <strong style="color:#EF4444;">KSh {{ fmt(settleSponsorship.outstanding) }}</strong>
          </div>

          <div class="row g-2">
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Paid On</label>
              <input type="date" class="st-input" v-model="settleForm.paid_on" />
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Amount (KES)</label>
              <input type="number" class="st-input" v-model="settleForm.amount" />
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">Method</label>
              <select class="st-input" v-model="settleForm.payment_method" style="padding:9px 10px;">
                <option value="mpesa">M-Pesa</option>
                <option value="bank">Bank</option>
                <option value="cash">Cash</option>
                <option value="cheque">Cheque</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="col-6">
              <label class="st-label" style="font-size:10px;">M-Pesa Code (if any)</label>
              <input class="st-input" v-model="settleForm.mpesa_code" style="text-transform:uppercase;" />
            </div>
            <div class="col-12">
              <label class="st-label" style="font-size:10px;">Notes</label>
              <input class="st-input" v-model="settleForm.notes" />
            </div>
          </div>
          <div class="d-flex gap-2 mt-3">
            <button class="btn st-btn-primary btn-sm" @click="submitSettle" :disabled="!(settleForm.amount > 0) || settling">
              <span v-if="settling" class="spinner-border spinner-border-sm me-1"></span>Record & Credit Wallet
            </button>
            <button class="btn st-btn-outline btn-sm" @click="settleSponsorship=null">Cancel</button>
          </div>
        </div>
      </div>

      <!-- Detail / Statement modal -->
      <div v-if="detail" class="pm-overlay" @click.self="detail = null">
        <div class="pm-modal" style="max-width:760px;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 style="color:#E8EDF4;margin:0;">{{ detail.sponsorship.student_name }} — Statement</h5>
            <button class="btn" style="color:#8BA4C4;font-size:18px;padding:0 6px;" @click="detail=null">✕</button>
          </div>
          <div style="font-size:13px;color:#8BA4C4;margin-bottom:12px;">
            <strong style="color:#E8EDF4;">{{ detail.sponsorship.sponsor_name }}</strong> ({{ detail.sponsorship.sponsor_type === 'ngo' ? 'NGO' : 'Individual' }}) ·
            Wallet balance: <strong :style="{color: Number(detail.wallet.balance) < 0 ? '#EF4444' : '#10B981'}">KSh {{ fmt(detail.wallet.balance) }}</strong> ·
            Daily limit: KSh {{ fmt(detail.wallet.spend_limit_daily, 0) }} ·
            Credit limit: KSh {{ fmt(detail.wallet.credit_limit, 0) }}
          </div>

          <div style="font-size:11px;color:#4A6A8A;text-transform:uppercase;font-weight:600;margin-bottom:6px;">Sponsor Settlements ({{ detail.settlements.length }})</div>
          <div style="overflow-x:auto;max-height:200px;">
            <table class="pm-table">
              <thead><tr><th>Date</th><th>Amount</th><th>Method</th><th>M-Pesa</th><th>Notes</th></tr></thead>
              <tbody>
                <tr v-for="s in detail.settlements" :key="s.id">
                  <td>{{ s.paid_on }}</td>
                  <td style="color:#10B981;font-weight:600;">{{ fmt(s.amount) }}</td>
                  <td>{{ s.payment_method }}</td>
                  <td style="font-family:monospace;font-size:11px;color:#8BA4C4;">{{ s.mpesa_code || '—' }}</td>
                  <td style="color:#8BA4C4;font-size:11px;">{{ s.notes || '' }}</td>
                </tr>
                <tr v-if="!detail.settlements.length"><td colspan="5" style="text-align:center;color:#4A6A8A;padding:14px;">No settlements yet.</td></tr>
              </tbody>
            </table>
          </div>

          <div style="font-size:11px;color:#4A6A8A;text-transform:uppercase;font-weight:600;margin:16px 0 6px;">Wallet Activity ({{ detail.transactions.length }})</div>
          <div style="overflow-x:auto;max-height:300px;">
            <table class="pm-table">
              <thead><tr><th>When</th><th>Type</th><th>Category</th><th class="text-end">Amount</th><th class="text-end">Balance</th><th>Description</th></tr></thead>
              <tbody>
                <tr v-for="t in detail.transactions" :key="t.id">
                  <td style="font-size:11px;">{{ t.created_at }}</td>
                  <td><span class="pm-badge" :class="t.type === 'credit' ? 'pm-badge-ok' : 'pm-badge-warn'">{{ t.type }}</span></td>
                  <td style="font-size:11px;color:#8BA4C4;">{{ t.category }}</td>
                  <td class="text-end" :style="{color: t.type==='credit' ? '#10B981' : '#F59E0B', fontWeight:600}">
                    {{ t.type === 'credit' ? '+' : '−' }} {{ fmt(t.amount) }}
                  </td>
                  <td class="text-end" :style="{color: Number(t.balance_after) < 0 ? '#EF4444' : '#8BA4C4'}">{{ fmt(t.balance_after) }}</td>
                  <td style="font-size:11px;color:#8BA4C4;">{{ t.description }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Navigation from "@/components/simi-auth/Navigation.vue";
import { executeJson, simitrack } from "@/api";
export default {
  name: 'SponsoredStudents',
  components: { Navigation },
  data() {
    const today = new Date().toISOString().slice(0, 10);
    return {
      view: 'sponsors',
      loading: false,
      sponsorships: [],
      summary: { active_count: 0, total_outstanding: 0, total_settled: 0 },
      filters: { status: 'active', search: '' },
      // Sponsors list
      sponsors: [], sponsorFilters: { status: 'active', search: '' },
      sponsorFormOpen: false,
      sponsorForm: { id: 0, type: 'ngo', name: '', contact_person: '', phone: '', email: '', monthly_budget: '', credit_cap: '', active: 1, notes: '' },
      savingSponsor: false,
      // Sponsor detail
      sponsorDetail: null,
      statementBusy: false, portalBusy: false, portalLink: '',
      backfillBusy: false,
      // Bulk convert
      bulkConvertOpen: false, bulkConvertSponsor: null,
      bulkSearch: '', bulkSearchTimer: null, bulkStudentResults: [], bulkSelectedIds: [],
      bulkConvertForm: { daily_limit: 350, credit_limit: 10000, start_date: today },
      bulkConverting: false,
      // Bulk settle
      bulkSettleOpen: false, bulkSettleSponsor: null,
      bulkSettleForm: { paid_on: today, amount: '', payment_method: 'mpesa', mpesa_code: '', notes: '', allocation: 'proportional' },
      bulkSettlePreview: [], manualSplit: {},
      bulkSettling: false,
      // Convert single (legacy flow)
      showConvertForm: false,
      studentSearch: '', studentSearchTimer: null, studentResults: [], selectedStudent: null,
      convertForm: {
        sponsor_type: 'ngo', sponsor_name: '', sponsor_phone: '', sponsor_email: '',
        daily_limit: 350, credit_limit: 10000, monthly_budget: '',
        start_date: today, end_date: '', notes: '',
      },
      converting: false,
      // Settle single
      settleSponsorship: null,
      settleForm: { paid_on: today, amount: '', payment_method: 'mpesa', mpesa_code: '', notes: '' },
      settling: false,
      // Detail single
      detail: null,
      reversingId: null,
      // Reports
      reportsOpen: false,
      reportTab: 'csv',
      reportBusy: false,
      csvBusy: false,
      dailyCap: null,
      trend: null, trendMonths: 6,
      lapsed: null, lapsedDays: 30,
    };
  },
  computed: {
    detailCapPct() {
      if (!this.sponsorDetail || !this.sponsorDetail.sponsor) return 0;
      const cap = Number(this.sponsorDetail.sponsor.credit_cap || 0);
      if (cap <= 0) return 0;
      const used = Number(this.sponsorDetail.total_outstanding || 0);
      return Math.round((used / cap) * 1000) / 10;
    },
    canConvert() {
      return this.selectedStudent && this.convertForm.sponsor_name.trim() !== '' && Number(this.convertForm.daily_limit) > 0;
    },
    previewSum() {
      if (this.bulkSettleForm.allocation === 'manual') {
        return Object.values(this.manualSplit).reduce((s, v) => s + (Number(v) || 0), 0);
      }
      return this.bulkSettlePreview.reduce((s, p) => s + Number(p.allocated || 0), 0);
    },
    previewTotalMatches() {
      return Math.abs(this.previewSum - Number(this.bulkSettleForm.amount || 0)) < 0.01;
    },
    canSubmitBulkSettle() {
      return Number(this.bulkSettleForm.amount) > 0 && this.bulkSettlePreview.length > 0 && this.previewTotalMatches;
    },
    trendTotals() {
      if (!this.trend) return { settled: 0, spent: 0 };
      return this.trend.totals_by_month.reduce((s, t) => ({ settled: s.settled + Number(t.settled), spent: s.spent + Number(t.spent) }), { settled: 0, spent: 0 });
    },
  },
  mounted() {
    this.loadAll();
    if (this.$route.query.reports === '1') {
      this.$nextTick(() => this.openReports());
    }
  },
  methods: {
    fmt(n, decimals = 2) { return Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); },
    capColor(pct) {
      const p = Number(pct || 0);
      if (p >= 95) return '#EF4444';
      if (p >= 80) return '#F59E0B';
      return '#10B981';
    },
    setView(v) { this.view = v; if (v === 'sponsors') this.loadSponsors(); else this.loadList(); },
    async loadAll() {
      this.loadList();
      this.loadSponsors();
    },
    async runBackfill() {
      if (!window.confirm('Apply the KSh 500 card fee to any sponsored students that were missed during conversion?\n\nThis is safe to run anytime — students who already paid the card fee will be skipped automatically.')) return;
      this.backfillBusy = true;
      try {
        const res = await executeJson({ function: 'backfillSponsoredCardFees' }, simitrack);
        if (res.data.success) {
          const d = res.data.data || {};
          const charged = (d.charged || []).length;
          const skipped = (d.skipped || []).length;
          const errors = (d.errors || []).length;
          const totalAmt = Number(d.totalAmount || 0);
          if (charged === 0 && errors === 0) {
            alert(`✓ Backfill complete\n\nNothing to do — all sponsored students already have their card fee posted.${skipped ? `\n\n${skipped} skipped (already paid / no wallet / etc.)` : ''}`);
          } else {
            const namesLine = (d.charged || []).slice(0, 5).map(c => `• ${c.name} (${c.admission_no})`).join('\n');
            const more = charged > 5 ? `\n• …and ${charged - 5} more` : '';
            alert(`✓ Backfill complete\n\nCharged: ${charged} student(s) — KSh ${totalAmt.toLocaleString()}\nSkipped: ${skipped}\nErrors: ${errors}\n\n${namesLine}${more}`);
          }
          this.loadAll();
        } else {
          alert(res.data.message || 'Backfill failed');
        }
      } catch (e) {
        alert(e.response?.data?.message || e.message || 'Backfill failed');
      }
      this.backfillBusy = false;
    },
    async loadSponsors() {
      this.loading = true;
      try {
        const res = await executeJson({ function: 'listSponsors', status: this.sponsorFilters.status, search: this.sponsorFilters.search }, simitrack);
        if (res.data.success) this.sponsors = res.data.data.sponsors || [];
      } catch (e) {}
      this.loading = false;
    },
    openSponsorForm(s) {
      if (s) {
        this.sponsorForm = { id: s.id, type: s.type, name: s.name, contact_person: s.contact_person || '', phone: s.phone || '', email: s.email || '', monthly_budget: s.monthly_budget || '', credit_cap: s.credit_cap || '', active: Number(s.active), notes: s.notes || '' };
      } else {
        this.sponsorForm = { id: 0, type: 'ngo', name: '', contact_person: '', phone: '', email: '', monthly_budget: '', credit_cap: '', active: 1, notes: '' };
      }
      this.sponsorFormOpen = true;
    },
    async submitSponsor() {
      this.savingSponsor = true;
      try {
        const fn = this.sponsorForm.id ? 'updateSponsor' : 'createSponsor';
        const res = await executeJson({ function: fn, ...this.sponsorForm }, simitrack);
        if (res.data.success) { this.sponsorFormOpen = false; this.loadSponsors(); }
        else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.savingSponsor = false;
    },
    async openSponsorDetail(s) {
      this.portalLink = '';
      try {
        const res = await executeJson({ function: 'getSponsorDetail', id: s.id }, simitrack);
        if (res.data.success) this.sponsorDetail = res.data.data;
        else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
    },
    openBulkConvert(sponsor) {
      this.bulkConvertSponsor = sponsor;
      this.bulkSearch = ''; this.bulkStudentResults = []; this.bulkSelectedIds = [];
      this.bulkConvertOpen = true;
    },
    searchBulkStudents() {
      clearTimeout(this.bulkSearchTimer);
      this.bulkSearchTimer = setTimeout(async () => {
        if ((this.bulkSearch || '').length < 2) { this.bulkStudentResults = []; return; }
        try {
          const res = await executeJson({ function: 'searchStudentsForSponsorship', query: this.bulkSearch }, simitrack);
          if (res.data.success) this.bulkStudentResults = res.data.data || [];
        } catch (e) {}
      }, 220);
    },
    toggleBulkSelect(s) {
      const idx = this.bulkSelectedIds.indexOf(s.id);
      if (idx >= 0) this.bulkSelectedIds.splice(idx, 1);
      else this.bulkSelectedIds.push(s.id);
    },
    async submitBulkConvert() {
      this.bulkConverting = true;
      try {
        const res = await executeJson({
          function: 'linkStudentsToSponsor',
          sponsor_id: this.bulkConvertSponsor.id,
          student_ids: JSON.stringify(this.bulkSelectedIds),
          ...this.bulkConvertForm,
        }, simitrack);
        if (res.data.success) {
          alert(`✓ ${res.data.message}`);
          this.bulkConvertOpen = false;
          if (this.sponsorDetail) this.openSponsorDetail(this.sponsorDetail.sponsor);
          this.loadSponsors();
        } else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.bulkConverting = false;
    },
    openBulkSettle(sponsor) {
      this.bulkSettleSponsor = sponsor;
      this.bulkSettleForm = { paid_on: new Date().toISOString().slice(0,10), amount: '', payment_method: 'mpesa', mpesa_code: '', notes: '', allocation: 'proportional' };
      this.bulkSettlePreview = []; this.manualSplit = {};
      this.bulkSettleOpen = true;
    },
    setAllocation(method) {
      this.bulkSettleForm.allocation = method;
      this.refreshBulkPreview();
    },
    async refreshBulkPreview() {
      const amt = Number(this.bulkSettleForm.amount);
      if (!this.bulkSettleSponsor || !amt || amt <= 0) { this.bulkSettlePreview = []; return; }
      if (this.bulkSettleForm.allocation === 'manual') {
        // Build a row per active sponsorship if we don't already have one
        if (!this.bulkSettlePreview.length) {
          try {
            const res = await executeJson({ function: 'previewSponsorAllocation', sponsor_id: this.bulkSettleSponsor.id, amount: amt, allocation: 'proportional' }, simitrack);
            if (res.data.success) {
              this.bulkSettlePreview = res.data.data.allocation || [];
              this.manualSplit = {};
              this.bulkSettlePreview.forEach(p => { this.manualSplit[p.sponsorship_id] = Number(p.allocated || 0); });
            }
          } catch (e) {}
        }
        return;
      }
      try {
        const res = await executeJson({ function: 'previewSponsorAllocation', sponsor_id: this.bulkSettleSponsor.id, amount: amt, allocation: this.bulkSettleForm.allocation }, simitrack);
        if (res.data.success) this.bulkSettlePreview = res.data.data.allocation || [];
      } catch (e) {}
    },
    async submitBulkSettle() {
      this.bulkSettling = true;
      try {
        const payload = {
          function: 'recordSponsorBulkSettlement',
          sponsor_id: this.bulkSettleSponsor.id,
          ...this.bulkSettleForm,
        };
        if (this.bulkSettleForm.allocation === 'manual') {
          payload.manual_split = JSON.stringify(this.manualSplit);
        }
        const res = await executeJson(payload, simitrack);
        if (res.data.success) {
          alert(`✓ ${res.data.message}`);
          this.bulkSettleOpen = false;
          if (this.sponsorDetail) this.openSponsorDetail(this.sponsorDetail.sponsor);
          this.loadSponsors();
        } else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.bulkSettling = false;
    },
    async downloadStatementPdf(sponsor) {
      this.statementBusy = true;
      try {
        const dateFrom = new Date(); dateFrom.setMonth(dateFrom.getMonth() - 1);
        const res = await executeJson({ function: 'downloadSponsorStatementPdf', sponsor_id: sponsor.id, dateFrom: dateFrom.toISOString().slice(0, 10), dateTo: new Date().toISOString().slice(0, 10) }, simitrack);
        if (res.data.success) {
          const { pdf_b64, filename } = res.data.data;
          const byteChars = atob(pdf_b64);
          const bytes = new Uint8Array(byteChars.length);
          for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
          const blob = new Blob([bytes], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
          URL.revokeObjectURL(url);
        } else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.statementBusy = false;
    },
    async emailStatement(sponsor) {
      this.statementBusy = true;
      try {
        const dateFrom = new Date(); dateFrom.setMonth(dateFrom.getMonth() - 1);
        const res = await executeJson({ function: 'emailSponsorStatement', sponsor_id: sponsor.id, dateFrom: dateFrom.toISOString().slice(0, 10), dateTo: new Date().toISOString().slice(0, 10) }, simitrack);
        if (res.data.success) alert('✓ ' + res.data.message);
        else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.statementBusy = false;
    },
    async getPortalLink(sponsor) {
      this.portalBusy = true;
      try {
        const res = await executeJson({ function: 'generateSponsorPortalToken', sponsor_id: sponsor.id }, simitrack);
        if (res.data.success) this.portalLink = res.data.data.url;
      } catch (e) {}
      this.portalBusy = false;
    },
    async reverseSettlement(t) {
      const reason = prompt(`Reverse settlement of KSh ${this.fmt(t.amount)} from ${t.paid_on}?\n\nThis will DEBIT the student's wallet by the same amount.\nReason (optional):`, 'Admin reversal');
      if (reason === null) return;
      this.reversingId = t.id;
      try {
        const res = await executeJson({ function: 'reverseSponsorSettlement', id: t.id, reason: reason || 'Admin reversal' }, simitrack);
        if (res.data.success) {
          if (this.sponsorDetail) this.openSponsorDetail(this.sponsorDetail.sponsor);
          this.loadSponsors();
        } else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.reversingId = null;
    },
    openReports() {
      this.reportsOpen = true;
      this.setReportTab(this.reportTab || 'csv');
    },
    async setReportTab(tab) {
      this.reportTab = tab;
      if (tab === 'cap' && !this.dailyCap) await this.loadDailyCap();
      if (tab === 'trend' && !this.trend)  await this.loadTrend();
      if (tab === 'lapsed' && !this.lapsed) await this.loadLapsed();
    },
    capColor(b) { return { capped: '#EF4444', '90_100': '#F59E0B', '50_90': '#4FC3F7', under_50: '#10B981' }[b] || '#8BA4C4'; },
    formatMonth(ym) {
      // 'YYYY-MM' → 'Mon YY'
      const [y, m] = ym.split('-');
      const names = ['', 'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return `${names[Number(m)] || m} ${y.slice(2)}`;
    },
    async downloadCsv(level) {
      this.csvBusy = true;
      try {
        const res = await executeJson({ function: 'exportSponsorsCsv', level }, simitrack);
        if (res.data.success) {
          const { csv, filename } = res.data.data;
          const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
          URL.revokeObjectURL(url);
        } else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.csvBusy = false;
    },
    async loadDailyCap() {
      this.reportBusy = true;
      try {
        const res = await executeJson({ function: 'getDailyCapReport' }, simitrack);
        if (res.data.success) this.dailyCap = res.data.data;
      } catch (e) {}
      this.reportBusy = false;
    },
    async loadTrend() {
      this.reportBusy = true; this.trend = null;
      try {
        const res = await executeJson({ function: 'getSponsorTrend', months: this.trendMonths }, simitrack);
        if (res.data.success) this.trend = res.data.data;
      } catch (e) {}
      this.reportBusy = false;
    },
    async loadLapsed() {
      this.reportBusy = true; this.lapsed = null;
      try {
        const res = await executeJson({ function: 'getLapsedSponsorships', days: this.lapsedDays }, simitrack);
        if (res.data.success) this.lapsed = res.data.data;
      } catch (e) {}
      this.reportBusy = false;
    },
    async sendPortalLink(sponsor, channel) {
      this.portalBusy = true;
      try {
        const res = await executeJson({ function: 'sendSponsorPortalLink', sponsor_id: sponsor.id, channel }, simitrack);
        if (res.data.success) { alert('✓ ' + res.data.message); this.portalLink = res.data.data.url; }
        else alert(res.data.message);
      } catch (e) { alert(e.response?.data?.message || e.message); }
      this.portalBusy = false;
    },
    async loadList() {
      this.loading = true;
      try {
        const res = await executeJson({ function: 'listSponsorships', status: this.filters.status, search: this.filters.search }, simitrack);
        if (res.data.success) {
          this.sponsorships = res.data.data.sponsorships || [];
          this.summary = {
            active_count: res.data.data.active_count || 0,
            total_outstanding: res.data.data.total_outstanding || 0,
            total_settled: res.data.data.total_settled || 0,
          };
        }
      } catch (e) {}
      this.loading = false;
    },
    searchStudents() {
      clearTimeout(this.studentSearchTimer);
      this.studentSearchTimer = setTimeout(async () => {
        if ((this.studentSearch || '').length < 2) { this.studentResults = []; return; }
        try {
          const res = await executeJson({ function: 'searchStudentsForSponsorship', query: this.studentSearch }, simitrack);
          if (res.data.success) this.studentResults = res.data.data || [];
        } catch (e) {}
      }, 220);
    },
    selectStudent(s) { this.selectedStudent = s; },
    async submitConvert() {
      this.converting = true;
      try {
        const payload = { function: 'convertToSponsoredWallet', studentId: this.selectedStudent.id, ...this.convertForm };
        const res = await executeJson(payload, simitrack);
        if (res.data.success) {
          this.showConvertForm = false;
          this.selectedStudent = null;
          this.studentSearch = ''; this.studentResults = [];
          this.convertForm.sponsor_name = ''; this.convertForm.sponsor_phone = ''; this.convertForm.sponsor_email = '';
          this.convertForm.notes = ''; this.convertForm.monthly_budget = ''; this.convertForm.end_date = '';
          this.loadList();
        } else {
          alert(res.data.message || 'Failed to convert');
        }
      } catch (e) {
        alert('Error: ' + (e.response?.data?.message || e.message));
      }
      this.converting = false;
    },
    openSettle(s) {
      this.settleSponsorship = s;
      this.settleForm = { paid_on: new Date().toISOString().slice(0,10), amount: s.outstanding || '', payment_method: 'mpesa', mpesa_code: '', notes: '' };
    },
    async submitSettle() {
      this.settling = true;
      try {
        const payload = { function: 'recordSponsorSettlement', sponsorship_id: this.settleSponsorship.id, ...this.settleForm };
        const res = await executeJson(payload, simitrack);
        if (res.data.success) {
          this.settleSponsorship = null;
          this.loadList();
        } else {
          alert(res.data.message || 'Failed to record settlement');
        }
      } catch (e) {
        alert('Error: ' + (e.response?.data?.message || e.message));
      }
      this.settling = false;
    },
    async openDetail(s) {
      try {
        const res = await executeJson({ function: 'getSponsorshipDetail', id: s.id }, simitrack);
        if (res.data.success) this.detail = res.data.data;
      } catch (e) {}
    },
    async endIt(s) {
      const revert = confirm(`End sponsorship for ${s.student_name}?\n\nClick OK to ALSO revert the wallet to prepaid (outstanding negative balance stays).\nClick Cancel to keep wallet on credit mode.`);
      try {
        const res = await executeJson({ function: 'endSponsorship', id: s.id, revert_wallet: revert ? 1 : 0 }, simitrack);
        if (res.data.success) this.loadList();
        else alert(res.data.message);
      } catch (e) {}
    },
  },
};
</script>

<style scoped>
.st-page{min-height:100vh;background:#0A1628;padding-top:70px;}
.st-back{color:#8BA4C4;font-size:22px;text-decoration:none;padding:4px;}.st-back:hover{color:#4FC3F7;}
.st-page-title{color:#E8EDF4;font-size:18px;font-weight:700;margin:0;}
.st-section{background:#0F2347;border:1px solid #1A3A6A;border-radius:14px;}
.st-label{color:#8BA4C4;font-size:12px;font-weight:600;margin-bottom:4px;display:block;}
.st-input{width:100%;background:#0A1628;border:1px solid #1A3A6A;border-radius:8px;padding:8px 12px;color:#E8EDF4;font-size:13px;outline:none;}.st-input:focus{border-color:#2E86DE;}
.st-btn-primary{background:linear-gradient(135deg,#2E86DE,#1A6BC4);color:#fff;border:none;font-weight:600;border-radius:8px;padding:8px 16px;font-size:13px;}
.st-btn-primary:disabled{opacity:.6;}
.st-btn-outline{background:transparent;border:1px solid #1A3A6A;color:#8BA4C4;font-weight:600;border-radius:8px;padding:8px 16px;font-size:13px;}.st-btn-outline:hover{border-color:#4FC3F7;color:#4FC3F7;}

.pm-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:10px;margin-bottom:16px;}
.pm-card{background:#0F2347;border:1px solid #1A3A6A;border-radius:10px;padding:14px;border-left:3px solid #1A3A6A;}
.pm-card-label{font-size:10px;color:#4A6A8A;text-transform:uppercase;font-weight:600;letter-spacing:.5px;}
.pm-card-value{font-size:20px;font-weight:800;margin:2px 0;}
.pm-card-sub{font-size:11px;color:#8BA4C4;}

.pm-badge{display:inline-block;padding:2px 8px;border-radius:4px;font-size:10px;font-weight:600;}
.pm-badge-ok{background:rgba(16,185,129,.15);color:#10B981;}
.pm-badge-warn{background:rgba(245,158,11,.15);color:#F59E0B;}
.pm-badge-info{background:rgba(79,195,247,.15);color:#4FC3F7;}
.pm-badge-reversed{background:rgba(239,68,68,.15);color:#EF4444;}

.pm-table{width:100%;border-collapse:collapse;font-size:12px;color:#E8EDF4;}
.pm-table thead tr{background:#0A1628;}
.pm-table th{padding:8px;color:#4FC3F7;font-weight:600;text-align:left;font-size:10px;text-transform:uppercase;border-bottom:2px solid #1A3A6A;white-space:nowrap;}
.pm-table td{padding:7px 8px;border-bottom:1px solid #1A3A6A;}
.pm-table tr:hover{background:rgba(46,134,222,.05);}
.text-end{text-align:right;}

.pm-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7);display:flex;align-items:center;justify-content:center;z-index:999;padding:20px;}
.pm-modal{background:#0D2B5E;border-radius:14px;padding:24px;width:100%;max-width:560px;max-height:90vh;overflow-y:auto;border:1px solid #1A3A6A;}
.pm-student{padding:8px 12px;border-radius:6px;cursor:pointer;margin-bottom:3px;background:#0A1628;border:1px solid #1A3A6A;font-size:13px;}
.pm-student:hover{border-color:#4FC3F7;}.pm-student.selected{border-color:#10B981;background:rgba(16,185,129,.08);}
</style>
